import { useEffect, useState } from 'react'
import { CouponUserType } from 'types/coupon_user'
import { db } from 'firebase/index'

const useQueryCouponUsers = (couponId: string, limit?: number): CouponUserType[] => {
  const [couponUsers, setCouponUsers] = useState<CouponUserType[]>([])
  useEffect(() => {
    if (!couponId) return
    let query = db.collection('coupons').doc(couponId).collection('coupon_users').orderBy('created_at', 'desc')
    if (limit) {
      query = query.limit(limit)
    }
    query
      .get()
      .then((snapshots) => {
        const users: CouponUserType[] = []
        snapshots.forEach((snapshot) => {
          const data = snapshot.data() as CouponUserType
          users.push(data)
        })
        setCouponUsers([...users])
      })
      .catch((error) => {
        console.error(error)
      })
  }, [couponId, limit])
  return couponUsers
}

export default useQueryCouponUsers
